<template>
    <div>
        <!-- Chatroom Register Button -->
        <v-btn
            color="error"
            dark
            @click="dialog = true"
            v-if="profileRegisteredBtnTag == 'register' && showBeInRegister"
        >
            {{ $t('screener.chatroom.button') }}
        </v-btn>

        <template v-if="profileRegisteredBtnTag == 'register' && showBeInRegister">
            <v-dialog
                v-model="dialog"
                persistent
                max-width="600px"
            >
            <!-- Chat room Register Button -->
                <div class="chatroom">
                    <div class="form-header">
                        <h2>{{ $t('screener.chatroom.heading') }}</h2>
                        <button class="close-btn" @click.prevent="closeRegisterPopUp">&times;</button>
                    </div>
                    <!-- User Register Form -->
                    <RegisterForm 
                        ref="registerForm"
                        :consumer="profile"
                        :screener="screener"
                        @handleBeInInfo="handleBeInInfo"
                        @handleprofileRegistered="handleprofileRegistered"
                    />
                    <!-- User Register Form -->
                </div>
            </v-dialog>
        </template>
        <!-- Chatroom Register Button -->

        <!-- Chatroom Information Dialogue -->
        <template v-if="showChatRoomInformation">
            <v-dialog
                v-model="chatRoomInfoDialog"
                persistent
                max-width="600px"
            >
            <!-- Chat room Register Button -->
                <div class="chatroom">
                    <div class="form-header">
                        <h2>About Be-IN</h2>
                        <button class="close-btn" @click.prevent="showchatRoomRegisterForm">&times;</button>
                    </div>
                    <!-- User Register Form -->
                    <div class="input-group">
                        <PreviewTrailer
                            :url="beinChatFeatureInformationUrl"
                        ></PreviewTrailer>
                    </div>
                    
                    <button type="submit" class="submit-btn" @click="showchatRoomRegisterForm">
                        Register with Be in
                    </button>
                    <!-- User Register Form -->
                </div>
            </v-dialog>
        </template>
        <!-- Chatroom Information Dialogue -->

        <!-- ChatRoom Floating Button with Side Drawer -->
        <template v-else-if="profileRegisteredBtnTag == 'chat'">
             <div class="floating-button-container" v-if="showDefaultBeInButton">
                <button class="floating-button" @click="showDrawer = true">
                    <p>{{ $t('screener.chatroom.button') }}</p>
                    <div class="register-count"><p>{{ chatRoomUnreadMessagesCount }}</p></div>
                </button>
            </div>
            <ChatDrawer 
                :chatRoom="screener.chat_room"
                :userProfile="registeredProfile"
                :showDrawer="showDrawer" 
                :consumer="profile" 
                :roomMembers="filteredChatRoomMembers"
                :chatRoomChatHistory="chatRoomChatHistory"
                :unreadMessageCount="chatRoomUnreadMessagesCount"
                :selectedMemberForChat="selectedMemberForChat"
                @openDrawer="showDrawer = true" 
                @closeDrawer="showDrawer = false" 
                @handleChatSelection="handleChatSelection"
                @updateSenderProfile="updateSenderProfile"/>
        </template>
        <!-- ChatRoom Floating Button with Side Drawer -->
    </div>
</template>

<script>
import Vue from 'vue'
import * as API from '@/api';
import DEFINES from "@/defines";
import ChatRoomService from "@/services/ChatRoomService";
import { mapState, mapActions } from "vuex";
import { addUniqueMemberToList } from './helper/HelperFunctions'


import RegisterForm from './Members/RegisterForm.vue'
import ChatDrawer from './ChatDrawer.vue'
import PreviewTrailer from "@/components/screener/PreviewTrailer.vue";


export default {
    name: 'ChatContainer',
    components: {
        RegisterForm,
        ChatDrawer,
        PreviewTrailer  
    },
    computed: {
        ...mapState({
            profile: (state) => state.consumer.profile,
        }),
        filteredChatRoomMembers(){
            let filteredProfiles = []
            // Here we will filter out the Chat toom Members list with the blocked or rejected profiles 
            if (this.rejectedChatRoomProfiles.length > 0) {
                const rejectedProfileIDS = new Set(this.rejectedChatRoomProfiles.map(obj => obj.id));
                // Map over the first array and add is_rejected key
                filteredProfiles = this.chatRoomMembers.map(({ acceptedProfiles, ...obj }) => {
                    return {
                        ...obj,
                        is_rejected: rejectedProfileIDS.has(obj.id)
                    }
                });

            }else{
                filteredProfiles = this.chatRoomMembers.map(({ acceptedProfiles, ...obj }) => obj);
            }

            console.log();
            

            if (filteredProfiles.length > 0) {
                filteredProfiles.forEach(async (element) => {
                    await this.listenToMemberProfile(this.screener.chat_room.chat_room_id,element.id)
                })
            }

            this.totalChatMembers = filteredProfiles.length
            this.totalActiveMembers = filteredProfiles.filter(member => member.onlineStatus).length
            
            return filteredProfiles
        }
    },
    props: {
        screener: {
            type: Object,
            default: null,
        },
        showBeInRegister: {
            type: Boolean,
            default: null,
        },
        showDefaultBeInButton: {
            type: Boolean,
            default: true,
        },
    },
    async mounted() {
        // Check if The current User is Registered to the Chatroom
        await this.checkProfileExistence()
    },
    async created(){
        let _this = this
        window.addEventListener("beforeunload", async function (event) {
            await _this.updateMemberStatus(false)
        })
    },
    async beforeDestroy() {
        await this.updateMemberStatus(false)
        await this.deactivateListeners()
    },
    watch: {
        totalChatMembers(newVal) {
            this.$emit('update-total-participants', newVal);
        },
        totalActiveMembers(newVal) {
            this.$emit('update-total-active-members', newVal);
        },
        registeredProfile: {
            handler: async function(newVal, oldVal) {
                if (newVal && (!oldVal || newVal.id !== oldVal.id)) {
                    await this.updateMemberStatus(true)
                    await this.listenToSenderProfile(this.screener.chat_room.chat_room_id,newVal.id)
                    // Listen for the Unread Messages Count for the chats going on with the current user
                    await this.listenUnreadMessagesCount()
                }
            },
            deep: true
        }
    },
    data() {
        return {
            beinChatFeatureInformationUrl:DEFINES.BE_IN_INFO_VIDEO_URL,
            /**
             * This will use to determine weather to show the Register Button or Chat Button
             * profileRegisteredBtnTag=chat => Show Floating chatroom button
             * profileRegisteredBtnTag=register => Show Registerbutton
             */
            profileRegisteredBtnTag:null,
            dialog: false,
            showDrawer:false,
            chatRoomUnreadMessagesCount:0,
            registeredProfile:null,
            chatRoomMembers:[],
            rejectedChatRoomProfiles:[],
            chatRoomChatHistory:[],
            selectedMemberForChat:null,
            showChatRoomInformation:false,
            chatRoomInfoDialog:false,
            totalChatMembers:0,
            totalActiveMembers:0
        }
    },
    methods: {
        async checkProfileExistence() {
            
            var response = await API.chatRoom.checkMemberExistence({
                chat_room_id: this.screener.chat_room.id,
                consumer_id: this.profile.id
            });
             
            
            if (response.member_details) {
                
                await ChatRoomService.listenToMemberProfile(this.screener.chat_room.chat_room_id,response.member_details.id, async (snapshot) => {
                    this.registeredProfile = snapshot
                });
                
                this.isProfileRegistered = true
                this.showChatRoomRegisterButton = false
                this.profileRegisteredBtnTag = 'chat'
                
                // Lister to all the Related Listener for the Chatroom from the firebase
                await this.activateChatRoomListeners()
                
            } else {
                this.profileRegisteredBtnTag = 'register'
            }
        },
        closeRegisterPopUp() {
            this.dialog = false
            // Reset form fields when clicked on close
            this.$refs.registerForm.resetFormFields()
        },
        async activateChatRoomListeners() {
            return Promise.all([
                // Update The Current Member As online
                this.updateMemberStatus(true),
                // Listen to The Memebers In the Chatroom
                this.listenToChatRoomMembers(this.screener.chat_room.chat_room_id),
                // Listen to the Current Member Profile for Changes
                this.listenToSenderProfile(this.screener.chat_room.chat_room_id,this.registeredProfile.id),
                // Listen for the Unread Messages Count for the chats going on with the current user
                this.listenUnreadMessagesCount()
            ]).then((response) => {
                // console.log(response);
            })

        },
        async listenToChatRoomMembers(chat_room_id) {
            let self = this
            await ChatRoomService.listenToAddedMembers(chat_room_id, (newUser) => {
                if (newUser.consumer_id!=self.registeredProfile.consumer_id) {
                    addUniqueMemberToList(this.chatRoomMembers, newUser)
                }
            });

        },
        async updateMemberStatus(activityStatus) {
            await ChatRoomService.__updateMemberStatus(this.screener.chat_room.chat_room_id, this.registeredProfile.id, activityStatus)
        },
        async listenToSenderProfile(chat_room_id, profileId, consumerId) {
            let self = this
            await ChatRoomService.listenToMemberProfile(chat_room_id,profileId, (snapshot) => {
                let rejectedProfiles = []
                
                if ('rejectedProfiles' in snapshot) {
                    rejectedProfiles = Object.entries(snapshot.rejectedProfiles).map(([rejectedProfileDocID, profileData]) => ({
                        rejectedProfileDocID,
                        ...profileData
                    }));

                    if (rejectedProfiles.length > 0) {
                        self.rejectedChatRoomProfiles = rejectedProfiles
                    }
                }

                if ('acceptedProfiles' in snapshot) {
                    let chatUserList = Object.values(snapshot.acceptedProfiles)
                    if (chatUserList.length > 0 ) {
                        chatUserList.forEach(async (element) => {
                            const chatId = [self.registeredProfile.id, element.id].sort().join('_');
                            let privateChatRef = await ChatRoomService.__privateChatsReference(chat_room_id, chatId).once('value')
                            let privateChatRefSnapshot = privateChatRef.val();
                            
                            // let chatUnReadMessageCount = await ChatRoomService.__countUnreadMessagesPrivateChat(chat_room_id,chatId, element.id,consumerId)
                            let chatUnReadMessageCount = 0
                            addUniqueMemberToList(this.chatRoomChatHistory,{
                                ...element,
                                unreadMessaegCount:chatUnReadMessageCount,
                                latest_message:privateChatRefSnapshot.lastMessage
                            })
                        })
                    } 
                }
                
            });
        },
        async listenToMemberProfile(chat_room_id,memberId) {
            await ChatRoomService.listenToMemberProfile(chat_room_id,memberId, (snapshot) => {
                this.updateMemberProfile(memberId, snapshot)
            });
        },
        async deactivateListeners() {
            return Promise.all([
                //Listen to all The Members we have in a chatroom for the Current Logged in user
                ChatRoomService.stopListeningToAddedMembers(this.chatRoom.chat_room_id),
                // Listen to The member profile for Rejected Profiles and Chat history
                ChatRoomService.stoplisteningAllChatsForMember(this.chatRoom.chat_room_id, this.userProfile.id)

            ]).then((response) => {
                console.log(response);
                
            })
            
        },
        async listenUnreadMessagesCount() {
            let self = this
            await ChatRoomService.listenToPrivateChatsForMember(this.screener.chat_room.chat_room_id,this.registeredProfile.id, (snapshot) => {
                
                let totalUnreadMessageCount = 0
                
                // Listen to all the Chat Rooms
                let chatRoom = Object.keys(snapshot)
                .map(key => ({ id: key, ...snapshot[key] }))
                
                chatRoom.forEach(chat => {
                    
                    let chatRoomMessageArray = Object.keys(chat.messages)
                    .map(key => ({ id: key, ...chat.messages[key] }))
                    
                    let unreadMessagesList = chatRoomMessageArray.filter(message => 
                        message.senderId !== this.registeredProfile.id && message.isRead === false
                    );
                    
                    
                    if (unreadMessagesList.length > 0) {
                        // Update the new Message Tag so that we can show pulse effect
                        unreadMessagesList.forEach((message) => {
                            let senderIndex = self.chatRoomMembers.findIndex(member => member.id == message.senderId);
                            let senderObject = self.chatRoomMembers[senderIndex]
                            if (senderIndex !== -1) {
                                // Ensure the property exists before setting it
                                if (!senderObject.hasOwnProperty('newMessageSent')) {
                                    Vue.set(self.chatRoomMembers[senderIndex], 'newMessageSent', true);
                                } else {
                                    Vue.set(self.chatRoomMembers[senderIndex], 'newMessageSent', true);
                                }
                                
                            }
                        })
                    }

                    totalUnreadMessageCount += unreadMessagesList.length
                });
                
                self.chatRoomUnreadMessagesCount = totalUnreadMessageCount
                
            });
        },
        updateMemberProfile(member_id, payload) {
            // Step 1 Find the Index of the Member in the Online Users List and Update the Member Details
            let memberParticipantIndex = this.chatRoomMembers.findIndex(member => member.id == member_id);
            
            if (memberParticipantIndex !== -1) {
                Vue.set(this.chatRoomMembers, memberParticipantIndex, payload)
            }

            // Step 2 Find the Index of the Member in the Chats List and Upddate the detail
            let memberChatsIndex = this.chatRoomChatHistory.findIndex(member => member.id == member_id);
            let memberChatObject = this.chatRoomChatHistory[memberChatsIndex]

            if (memberChatsIndex !== -1) {
                Vue.set(this.chatRoomChatHistory, memberChatsIndex, {...memberChatObject,onlineStatus:payload.onlineStatus})
            }
            
            // Step 3: Update The Selected Member Profile for any realtime change ( For Chat Area )
            if (this.selectedMemberForChat && (this.selectedMemberForChat.id == member_id)) {
                this.selectedMemberForChat = payload
            }
            // Step 4: Update The Selected Member Profile for any realtime change ( For Profile View )
            if (this.selectedProfileToView && (this.selectedProfileToView.id == member_id)) {
                this.selectedProfileToView = payload
            }
        },
        async handleprofileRegistered(registeredUser) {
            let __this = this
            this.dialog = false;

            await this.$nextTick();

            await new Promise(resolve => setTimeout(resolve, 500));

            // Then update all the other values
            this.registeredProfile = registeredUser;
            this.showBeInRegister = false; // Make sure this is also set to false
            this.profileRegisteredBtnTag = 'chat';
            
            // Finally activate chat room listeners
            await this.activateChatRoomListeners();

            // this.registeredProfile = registeredUser
            // // Wait a small amount of time for dialog close animation
            // setTimeout(async () => {
            //     __this.profileRegisteredBtnTag = 'chat'
            //     await __this.activateChatRoomListeners()
            // }, 1000) // Adjust time based on your dialog transition duration
            
            // this.profileRegisteredBtnTag = 'chat'
            // await this.activateChatRoomListeners()
        },
        handleChatSelection(selectedChatMember) {
            this.selectedMemberForChat = selectedChatMember
        },
        handleBeInInfo() {
            this.profileRegisteredBtnTag = 'register'
            this.showChatRoomInformation = true
            this.chatRoomInfoDialog = true
        },
        showchatRoomRegisterForm() {
            this.profileRegisteredBtnTag = (this.registeredProfile) ? 'chat' : 'register'
            this.showChatRoomInformation = false
            this.chatRoomInfoDialog = false
        },
        
    }
}
</script>

<style scoped>
@import url('./css/chatroom.css');
</style>